var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('beast-header'),_c('div',{staticClass:"container"},[_c('beast-search-box',{on:{"searchEnded":_vm.updateSearch}}),_c('beast-packages-list',{on:{"keywordSearch":_vm.updateSearch}})],1),_c('beast-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }